export const formatDosage = (treatment: unknown): string | null => {
  if (treatment === undefined || treatment === null || treatment === '')
    return null;
  const map = (
    window as unknown as { treatmentDosageMap?: Record<string, string> | null }
  ).treatmentDosageMap;
  if (map) return map[String(treatment)] ?? null;
  const raw = String(treatment);
  return /mg/i.test(raw) ? raw : `${raw} mg`;
};
